export const WindowCloser = (
    name: string
) => {
    let event = new CustomEvent('window-closer', {
        detail: {
            name: name,
        },
    });
    window.dispatchEvent(event);
}